export const namespace = 'textQuestion';